import { ScreenReaderOnly } from '@capsule/consumer-design-system';

import { Container, Description, Header } from '../styles';

export const PasswordResetSuccess = () => {
  return (
    <Container>
      <Header>Please check your email</Header>

      <Description>We’ve sent a link to reset your password.</Description>

      <ScreenReaderOnly>You may close this window.</ScreenReaderOnly>
    </Container>
  );
};
